export default __webpack_public_path__ + "static/media/Staff of the Crustacean.fe5b0e0a.jpg";